export enum MODAL_TYPES {
  WRONG_NETWORK_MODAL = 'WRONG_NETWORK_MODAL',
  MARKETPLACE_BUY_ORDER_MODAL = 'MARKETPLACE_BUY_ORDER_MODAL',
  MARKETPLACE_SELL_ORDER_MODAL = 'MARKETPLACE_SELL_ORDER_MODAL',
}

export const INITIAL_MODAL_STATE = {
  current: null,
  props: null,
};
